import {Col} from 'antd';
import classnames from 'classnames';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import classNames from 'classnames';

interface EmbossedContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: any;
  className?: string;
}

const EmbossedContainer = (props: EmbossedContainerProps) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {children, className, ...rest} = props;

  return (
    <div className={classNames(classes.container, className)} {...rest}>
      {children}
    </div>
  );
};

export default EmbossedContainer;
